/* KP Grid Density Toggle — Phase 23
 * Vanilla JS (not Alpine) because Dawn's facets.js replaces #ProductGridContainer
 * innerHTML after AJAX filter updates, destroying Alpine bindings.
 * Uses MutationObserver to reapply column class after re-render.
 */
(function() {
  'use strict';

  var STORAGE_KEY = 'kp-grid-density';
  var DEFAULT_DENSITY = 4;
  var VALID = [3, 4];

  // Find the actual <ul class="product-grid"> grid element.
  // On collection pages #product-grid IS the <ul>.
  // On search pages #product-grid is a wrapper <div> — the <ul> is nested inside.
  function getGridElement() {
    var el = document.getElementById('product-grid');
    if (!el) return null;
    if (el.tagName === 'UL') return el;
    return el.querySelector('ul.product-grid') || el;
  }

  function getDefaultDensity() {
    var grid = getGridElement();
    if (grid && grid.dataset.defaultCols) {
      var val = parseInt(grid.dataset.defaultCols, 10);
      if (VALID.includes(val)) return val;
    }
    return DEFAULT_DENSITY;
  }

  function getDensity() {
    var saved = localStorage.getItem(STORAGE_KEY);
    var parsed = parseInt(saved, 10);
    return VALID.includes(parsed) ? parsed : getDefaultDensity();
  }

  function setDensity(n) {
    if (!VALID.includes(n)) return;
    localStorage.setItem(STORAGE_KEY, n);
    applyDensity(n);
    updateButtons(n);
  }

  function applyDensity(n) {
    var grid = getGridElement();
    if (!grid) return;
    VALID.forEach(function(v) {
      grid.classList.remove('grid--' + v + '-col-desktop');
    });
    grid.classList.add('grid--' + n + '-col-desktop');
  }

  function updateButtons(n) {
    document.querySelectorAll('[data-kp-density]').forEach(function(btn) {
      var val = parseInt(btn.getAttribute('data-kp-density'), 10);
      btn.classList.toggle('kp-density-active', val === n);
    });
  }

  function init() {
    var density = getDensity();
    applyDensity(density);
    updateButtons(density);

    // Delegate clicks on density buttons
    document.addEventListener('click', function(e) {
      var btn = e.target.closest('[data-kp-density]');
      if (btn) {
        var val = parseInt(btn.getAttribute('data-kp-density'), 10);
        setDensity(val);
      }
    });

    // MutationObserver: reapply density after Dawn's AJAX re-render
    var container = document.getElementById('ProductGridContainer');
    if (container) {
      var observer = new MutationObserver(function() {
        var d = getDensity();
        applyDensity(d);
      });
      observer.observe(container, { childList: true, subtree: false });
    }
  }

  // Run on DOMContentLoaded or immediately if already loaded
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
